import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faFileAlt,
  faUnderline,
} from "@fortawesome/free-solid-svg-icons";
import Config from "../../_config/config";
import Card from "react-bootstrap/Card";
import ApiService from "../../_services/ApiService";
import Loader from "./../../_components/loader/loader";
import swal from "sweetalert";
import Utils from "../../_helpers/utils";
import UserService from "../../_services/UserService";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
import { ILoader } from "../../_components/iloader/iloader";

const AWS = require("aws-sdk");
AWS.config.clear();
AWS.config.update({
  region: Config.AWSRegion,
  accessKeyId: Config.AWSAccessKeyId,
  secretAccessKey: Config.AWSSecretAccessKey,
});

class TestListDetails extends Component {
  static contextType = AppPropertiesContext;
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      message: null,
      loading: false,
      tests: [],
      download: "Download",
      testname: "Online Test",
      testCacheUrl: "",
      showIloader: false,
      fetchError: null,
      loopCount:0,
    };
    this.reloadTestListDetails = this.reloadTestListDetails.bind(this);
    this.downloadTest = this.downloadTest.bind(this);
    this.commingSoonTimeOuts = [];
  }

  componentDidMount() {
    let { testCacheUrl, testListData } = this.props.location.state || {};
    console.log(testCacheUrl);

    let paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);
    let enquiryId = params.get("enquiryId");
    if (enquiryId) {
      localStorage.setItem("enquiryId", enquiryId);
    }

    if (testListData) {
      this.sortTestListing(testListData);
      return this.setState(
        {
          loading: false,
          list: testListData,
        },
        () => {
          this.scanTest(testListData);
        }
      );
    }

    if (!testCacheUrl) {
      testCacheUrl = sessionStorage.getItem("testCacheUrl");
    }

    if (testCacheUrl?.includes("{enquiryId}")) {
      testCacheUrl = testCacheUrl.replace(
        "{enquiryId}",
        UserService.getEnquiryId
      );
    }
    if (testCacheUrl) {
      return this.setState({ testCacheUrl: testCacheUrl }, () =>
        this.reloadTestListDetails()
      );
    }

    this.reloadTestListDetails();
  }

  openTest = (testID, viewMode, feedbackForm) => {
    if (feedbackForm) {
      if (typeof feedbackForm === "string") {
        try {
          feedbackForm = JSON.parse(feedbackForm);
        } catch (err) {
          console.log(err);
        }
      }

      if (feedbackForm?.feedbackFormId) {
        console.log(feedbackForm, "here");
        this.props.history.push({
          pathname: `/feedback/form/${feedbackForm?.feedbackFormId}`,
          state: {
            testId: testID,
            viewMode,
            categoryId: this.props.match.params.id,
          },
        });
        return;
      }
    }
    var url =
      "/TestInstructions/" +
      testID +
      "?cat=" +
      this.props.match.params.id +
      "&view=" +
      viewMode;
    window.open(
      url,
      "Start Test",
      "height=" + window.screen.height + ",width=" + window.screen.width
    );
  };

  reloadTestListDetails() {
    var testlist = JSON.parse(localStorage.getItem("testlist")) || [];
    var online = navigator.onLine;
    if (online == false) {
      this.sortTestListing(testlist);
      this.setState({
        loading: false,
        list: testlist,
      });
      /*this.setState({ loading: true }, () => {
        ApiService.fetchTestList()
        .then((res) => {
            this.setState({
              loading: false,
              list: res.data
            });
        });
      }); */
    } else {
      const { testCacheUrl } = this.state;
      this.setState({ loading: true }, () => {
        ApiService.fetchTestList(
          testCacheUrl && testCacheUrl !== "undefined" ? testCacheUrl : null
        ).then((res) => {
          this.sortTestListing(res.data);
          this.setState(
            {
              loading: false,
              list: res.data,
              fetchError: null
            },
            () => {
              this.scanTest(res.data);
            }
          );
        })
        .catch((err) => {
          console.log(err);
          this.setState({fetchError: err, loading: false});
          setTimeout(()=>{
            this.reloadTestListDetails();
          },5000)
        });
      });
    }
  }

  scanTest = async (testList) => {
    const { id } = this.props.match.params || {};

    if (!id) return;

    if (!testList) return;
    if (testList[0]?.categoryBased !== true) return;

    let requiredTestArray = [];
    let requiredCategoryIndex = -1;

    testList[0]?.categoryBeans.forEach((testArray, index) => {
      if (testArray.id === Number(id)) {
        requiredTestArray = testArray.testDataBeans;
        requiredCategoryIndex = index;
        return;
      }
    });

    if (!requiredTestArray.length) return;

    const currentTime = await ApiService.fetchCurrentTime();

    requiredTestArray.forEach(async (test, index) => {
      if (test.status === "Open For Registration") {
        if (this.convertRegisterToStart(test.startDate)) {
          const startTime = this.dateStringToUnix(test.startDate);
          const endTime = this.dateStringToUnix(test.endDate);
          this.changeRegisterToTest(
            testList,
            requiredCategoryIndex,
            index,
            startTime,
            endTime,
            currentTime.unix_time * 1000
          );
        }
      }

      if (test.status === "Coming Soon") {
        console.log(test, "here");
        const testTimeInUnix = this.dateStringToUnix(test.startDate);
        this.changeToStartTest(
          requiredCategoryIndex,
          index,
          testTimeInUnix - currentTime.unix_time * 1000
        );
      }
    });
  };

  changeRegisterToTest = (
    testsList,
    categoryIndex,
    testIndex,
    startTime,
    endTime,
    currentTime
  ) => {
    console.log(startTime, currentTime);
    if (startTime > currentTime) {
      testsList[0].categoryBeans[categoryIndex].testDataBeans[
        testIndex
      ].status = "Coming Soon";

      this.setState({
        list: testsList,
      });
    } else if (startTime < currentTime && endTime > currentTime) {
      testsList[0].categoryBeans[categoryIndex].testDataBeans[
        testIndex
      ].status = "Launch";

      this.setState({
        list: testsList,
      });
    } else {
      testsList[0].categoryBeans[categoryIndex].testDataBeans[
        testIndex
      ].status = "Time Out";

      this.setState({
        list: testsList,
      });
    }
  };

  changeToStartTest = (categoryIndex, testIndex, interval) => {
    if (interval < -1) return;
    if(interval>2147483647) return;
    const currentTimeOut = setTimeout(() => {
      console.log("running", "here");
      const existingTestData = this.state.list;

      existingTestData[0].categoryBeans[categoryIndex].testDataBeans[
        testIndex
      ].status = "Launch";

      this.setState({
        list: existingTestData,
      });
    }, interval);

    this.commingSoonTimeOuts.push(currentTimeOut);
  };

  componentWillUnmount() {
    this.commingSoonTimeOuts.forEach((timeOut) => {
      clearTimeout(timeOut);
    });
  }

  dateStringToUnix = (date) => {
    if (!date || date === "--") return;
    // require date format is dd/mm/yy hr:min (AM/PM)
    const [dateString, time, meridiemIndicator] = date?.split(" ");

    let finalTime = time;

    if (meridiemIndicator === "PM"&& Number(finalTime.split(":")[0]) !==12) {
      finalTime = `${Number(finalTime.split(":")[0]) + 12}:${
        finalTime.split(":")[1]
      }`;
    }

    const splitedDate = dateString.split("/");

    const finalDate = `${splitedDate[1]}-${splitedDate[0]}-${splitedDate[2]}`;

    const udate = new Date(`${finalDate} ${finalTime}`).getTime();
    if (!isNaN(udate)) {
      var unixDate = udate;
    } else {
      //get month
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = monthNames[splitedDate[1] - 1];
      var unixDate = new Date(
        `${month} ${splitedDate[0]} ${splitedDate[2]}  ${finalTime}`
      ).getTime();
    }
    return unixDate;
  };

  sortTestListing = (testList) => {
    console.log("start");
    console.log(testList);
    const { id } = this.props.match.params || {};
    if(localStorage.getItem("test_parentcat_id") === null){
      localStorage.setItem("test_parentcat_id",testList[0]['id']);
    }

    if (!id) return;

    if (!testList) return;
    if (testList[0]?.categoryBased !== true) return;

    let requiredTestArray = [];

    testList[0]?.categoryBeans.forEach((testArray) => {
      if (testArray.id === Number(id)) {
        requiredTestArray = testArray.testDataBeans;
        return;
      }
    });

    if (!requiredTestArray.length) return;

    requiredTestArray.sort((a, b) => {
      const dateA = this.dateStringToUnix(a.startDate);
      const dateB = this.dateStringToUnix(b.startDate);
      return dateA - dateB;
    });
  };

  payCheck(path, testID) {
    this.setState({ loading: true }, () => {
      let payLoad = {
        type: "test",
        testId: testID,
      };
      ApiService.studentPayCheck(payLoad).then((res) => {
        this.setState({
          loading: false,
        });
        if (res.data.type == 2) {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = res.data.message;
          swal({
            title: "Alert",
            content: wrapper,
            dangerMode: true,
            buttons: true,
            className: "blue-card",
          }).then((willResume) => {
            if (willResume) {
            }
          });
        } else {
          this.props.history.push({
            pathname: path,
            state: { testEndDate: "", testCategory: "" },
          });
        }
      });
    });
  }

  routeChange(path, testID) {
    this.payCheck(path, testID);
  }

  routeChange2(path, endDate, testCategory) {
    this.props.history.push({
      pathname: path,
      state: { testEndDate: endDate, testCategory: testCategory },
    });
  }
  routeChange4(path, state) {
    this.props.history.push({
      pathname: path,
      state,
    });
  }

  routeChange3(path) {
    this.payCheck(path);
  }

  addUrlToCache(url) {
    window
      .fetch(url)
      .then(function (response) {
        caches.open("test-images").then(function (cache) {
          cache.add(url);
        });
      })
      .catch(function (error) {
        console.log("cache put image error " + error);
      });
  }

  showAlert(msg) {
    swal({
      title: "Alert",
      text: msg,
      dangerMode: true,
    });
  }

  downloadTest(testid) {
    ApiService.fetchTest(testid).then((res) => {
      if (
        res.data.status == 1 &&
        res.data.data.tests[0].testJSONFile != "TestJSONNotFound"
      ) {
        var d = new Date();
        var rand = d.getTime();
        var studentPdfResponse = res.data.data.tests[0].studentPdfResponse;
        ApiService.fetchTestJson(
          res.data.data.tests[0].testJSONFile + "?id=" + rand
        ).then((res) => {
          this.setState({ tests: res.data });
          //alert(JSON.stringify(res.data.testImages));
          var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
          if (oldTests.filter((test) => test.id == testid).length == 0) {
            res.data.resume = 0;
            res.data.studentPdfResponse = studentPdfResponse;
            oldTests.push(res.data);
            localStorage.setItem("tests", JSON.stringify(oldTests));
            this.props.history.replace(
              "/test-instructions/" + this.props.match.params.id + "/" + testid
            );
            /*var images = "";
                images = res.data.testImages;
                if(!images){
                }else{
                  //for(let i=0;i<images.length; i++){
                    //this.addUrlToCache(images[i].replace('http://','https://'));
                    //var per = (i/images.length)*100;
                    //progress(per);
                  //}
                }*/
            //this.addUrlToCache("https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=AM_HTMLorMML");
            //this.reloadTestListDetails();
          }
        });
      } else {
        swal({
          title: "Alert",
          text: "Online test not available. Please contact administrator",
          dangerMode: true,
        });
      }
    });
  }

  logout = () => {
    const loginRoute = sessionStorage.getItem("loginRoute");
    this.props.history.push({
      pathname: "/logout",
      state: { redirectRoute: loginRoute || "/" },
    });
  };

  findTestConfig = (id) => {
    const { list } = this.state;
    if (!list[0]?.categoryBased) return true;

    let res = true;

    list[0]?.categoryBeans?.forEach((category) => {
      if (category.id === Number(id)) {
        const testConfig = JSON.parse(category.testConfig || "{}");
        if (
          testConfig?.cumulativeReport?.enabled === "false" ||
          testConfig?.cumulativeReport?.enabled === false
        ) {
          res = false;
          return;
        } else {
          res = true;
          return;
        }
      }
    });
    return res;
  };

  render() {
    let portlet = JSON.parse(localStorage.getItem("portlet")) || [];
    const homeRoute = sessionStorage.getItem("homeRoute");
    const { loading, fetchError } = this.state;
    const { id } = this.props.match.params;
    const showTestAnalysis = this.findTestConfig(id);
    console.log(showTestAnalysis);

    return (
      <div className="testlist">
        {
          <Container fluid>
            <div
              className={`module-header-step2 ${
                portlet.class ? portlet.class : "test-list-default-portlet"
              }`}
            >
              <div className="">
                <div className="back">
                  {homeRoute === "/TestList" ? null : (
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      onClick={this.props.history.goBack}
                    />
                  )}
                  {showTestAnalysis && (
                    <span
                      className="test-list-logout"
                      style={{
                        marginRight: "110px",
                      }}
                      onClick={() =>
                        this.routeChange2(
                          "/test-analysis/" + this.props.match.params.id
                        )
                      }
                    >
                      Test Progress Tracker
                    </span>
                  )}
                  <span className="test-list-logout" onClick={this.logout}>
                    Logout
                  </span>
                </div>
                <h4 id="testname">Test list details</h4>
              </div>
            </div>
            {fetchError ? (
              <div className="test-list-error-wrapper">
                <span>
                  Uh oh, it looks like you're facing a connectivity issue to the
                  server.
                </span>
                <span>
                  Don't worry, we're trying to reload the page for you.... 
                </span>
                <span>
                  If you'd like to try refreshing manually, <span onClick={()=>window.location.reload()} className="test-details-logout">click here.</span>
                </span>
              </div>
            ) :   loading ? <Loader /> : this.renderCard()}
          </Container>
        }
      </div>
    );
  }

  openDashboard = async (id) => {
    this.setState({ showIloader: true });
    try {
      const dashboardResponse = await ApiService.fetchDashboardUrl(id);
      const { URLString } = dashboardResponse?.data?.data;
      window.open(URLString);
      this.setState({ showIloader: false });
    } catch (err) {
      console.log(err);
    }
  };

  renderCard() {
    let data = this.state.list;
    return (
      <div className="card_list">
        <ILoader isShow={this.state.showIloader} loadingText="please wait.." />
        {data.map((item, index) => {
          return (
            <div>
              {this.renderTest(
                data[index].id,
                data[index].name,
                data[index].categoryBased,
                data[index].categoryBeans
              )}
            </div>
          );
        })}
      </div>
    );
  }

  renderTest(id, name, categoryBased, categoryBeans) {
    let isMobile = Utils.isMobileDevice();
    console.log('catType '+categoryBased);
    this.state.loopCount = 0;
    return (
      <div>
        {categoryBased === true
          ? categoryBeans.map((c, i) => {
              let test_parentcat_id =
                localStorage.getItem("test_parentcat_id") || 0;
                console.log('test_parentId '+test_parentcat_id);
              if (
                c.id == this.props.match.params.id &&
                id == test_parentcat_id
              ) {
                document.getElementById("testname").innerHTML = c.name;
                return (
                  <div className="">
                    {isMobile === true ? (
                      <div className="card_list">
                        {this.renderTestListMobile(c.testDataBeans)}{" "}
                      </div>
                    ) : (
                      <div className="download_list zoom_video_list card_list">
                        {this.renderTestListDesktop(c.testDataBeans)}
                      </div>
                    )}
                  </div>
                );
              }
            })
          : categoryBeans.map((c, i) => {
              if (id == this.props.match.params.id) {
                document.getElementById("testname").innerHTML = name;
                return (
                  <div className="">
                    {isMobile === true ? (
                      <div className="card_list">
                        {this.renderTestListMobile(c.testDataBeans)}{" "}
                      </div>
                    ) : (
                      <div className="download_list zoom_video_list card_list">
                        {this.renderTestListDesktop(c.testDataBeans)}
                      </div>
                    )}
                  </div>
                );
              }
            })}
      </div>
    );
  }

  renderTestList(beans) {
    return (
      <div>
        {beans.map((d, j) => {
          var button;
          var sedate = "";
          if (d.startDate != "--") {
            sedate = d.startDate + "-" + d.endDate;
          } else {
            sedate = <br />;
          }

          if (d.status == "Launch") {
            var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
            if (oldTests.filter((test) => test.id == d.id).length == 0) {
              button = (
                <button
                  onClick={() => this.downloadTest(d.id)}
                  className="download launch-button"
                >
                  Start
                </button>
              );
            } else {
              button = (
                <button
                  onClick={() =>
                    this.routeChange(
                      "/test-instructions/" +
                        this.props.match.params.id +
                        "/" +
                        d.id,
                      d.id
                    )
                  }
                  className="download launch-button"
                >
                  Start
                </button>
              );
              for (var i = 0; i < oldTests.length; i++) {
                if (oldTests[i].submit == 1 && oldTests[i].id == d.id) {
                  button = (
                    <button
                      onClick={() =>
                        this.routeChange2(
                          "/test-submit/" +
                            this.props.match.params.id +
                            "/" +
                            d.id
                        )
                      }
                      className="download launch-button"
                    >
                      Submit
                    </button>
                  );
                } else if (oldTests[i].resume == 1 && oldTests[i].id == d.id) {
                  button = (
                    <button
                      onClick={() =>
                        this.routeChange(
                          "/test-instructions/" +
                            this.props.match.params.id +
                            "/" +
                            d.id,
                          d.id
                        )
                      }
                      className="download launch-button"
                    >
                      Resume
                    </button>
                  );
                }
              }
            }
          } else if (d.status == "Time Out") {
            var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
            button = (
              <button
                onClick={() =>
                  this.showAlert("The test is closed at  " + d.endDate)
                }
                className="download time-out-button"
              >
                {d.status}
              </button>
            );
            for (var i = 0; i < oldTests.length; i++) {
              if (oldTests[i].resume == 1 && oldTests[i].id == d.id) {
                button = (
                  <button
                    onClick={() =>
                      this.routeChange2(
                        "/test-submit/" +
                          this.props.match.params.id +
                          "/" +
                          d.id
                      )
                    }
                    className="download time-out-button"
                  >
                    {d.status}
                  </button>
                );
              }
            }
          } else if (d.status == "View Result") {
            button = (
              <button
                onClick={() =>
                  this.routeChange2(
                    "/test-result/" + this.props.match.params.id + "/" + d.id,
                    d.endDate
                  )
                }
                className="download result-button"
              >
                Result
              </button>
            );
          } else if (d.status == "Coming Soon") {
            button = (
              <button
                onClick={() =>
                  this.showAlert("The test is available between " + sedate)
                }
                className="download coming-soon-button"
              >
                {d.status}
              </button>
            );
          }

          return (
            <Card>
              <Card.Body>
                <div className="cardbody">
                  <FontAwesomeIcon className="Book" icon={faFileAlt} />
                  <p className="option">
                    {d.name}
                    <div className="testdate">{sedate}</div>
                  </p>
                  {button}
                </div>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    );
  }

  submitTimeOut = (testId) => {
    const tenant = localStorage.getItem("tenant") || Config.siteTitle;
    const userObject = JSON.parse(localStorage.getItem("user"));
    console.log(userObject);
    console.log(userObject.userId);

    //'https://tuningfork-'+ Config.siteMode +'.s3.amazonaws.com/'+ tenant +'/uploads/testPapers/'+ testId +'/'+ testId +'.json'
    let testUrl =
      "https://tuningfork-" +
      Config.siteMode +
      ".s3.amazonaws.com/" +
      tenant +
      "/uploads/testPapers/" +
      testId +
      "/" +
      testId +
      ".json";

    const studentTestData = {
      tenant: tenant,
      testId: testId,
      userId: userObject.userId,
      s3Url: testUrl,
    };

    //console.log(student_response);

    //alert(JSON.stringify(student_response));
    var lambda = new AWS.Lambda();
    var params = {
      FunctionName: "testResume" /* required */,
      Payload: JSON.stringify(studentTestData),
    };

    lambda.invoke(params, function (err, response) {
      if (err) {
        //alert(Config.CONNECTION_ERROR_MSG);
        console.log(err);
        // console.log(err, err.stack); // an error occurred
      } else {
        let res = JSON.parse(response.Payload);
        let testObject = res.data;
        console.log(testObject);
        const student_response = {
          tenant: tenant,
          testId: testId,
          userId: [userObject.userId],
          testSubmit: true,
          submitStatus: 1,
          autoSubmitToRDS: testObject?.testConfig?.autoSubmitToRDS,
          siteUrl: Config.siteUrl,
        };

        console.log(student_response);

        var lambda = new AWS.Lambda();
        var params = {
          FunctionName: "testResponses" /* required */,
          Payload: JSON.stringify(student_response),
        };

        lambda.invoke(params, function (err, data) {
          if (err) {
            console.log(err, err.stack); // an error occurred
            alert(Config.CONNECTION_ERROR_MSG);
          } else {
            let res = JSON.parse(data.Payload);
            //console.log(data);  // successful response

            //if(res.status=="success" && testObject?.testConfig?.autoSubmitToRDS == true){
            //that.SubmitToRDS();
            //}else
            console.log(res);

            if (res.status == "success") {
              console.log("sucesssssssss");
              swal({
                text: "Test submitted successfully.",
                icon: "success",
                button: "Ok",
                allowOutsideClick: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              }).then(() => {
                window.location.reload();
              });
            }
          }
        });
      }
    });
  };

  showTimoutTest = (testEndTime) => {
    const { list } = this.state;
    const { id } = this.props.match.params;
    if (!list[0].categoryBased) return true;

    let testConfig = {};

    list[0].categoryBeans?.forEach((category) => {
      if (category?.id?.toString() === id) {
        testConfig = category.testConfig;
      }
    });

    if (typeof testConfig === "string") {
      try {
        testConfig = JSON.parse(testConfig);
      } catch (err) {
        console.log(err);
      }
    }

    if (
      testConfig?.hideTimeOutTests === undefined ||
      testConfig?.hideTimeOutTests === null
    )
      return true;

    const testEndTimeInUnix = this.dateStringToUnix(testEndTime);

    const currentTime = new Date().getTime();

    return (
      currentTime - testEndTimeInUnix < 86400000 * testConfig.hideTimeOutTests
    );
  };

  renderTestListMobile(beans) {
    const { getTestDahboardById, getTestFooter } = this.context;
    const { id } = this.props.match.params;
    const testDashboardId = getTestDahboardById(Number(id));
    const footer = getTestFooter(Number(id));

    return (
      <div>
        {testDashboardId !== null && (
          <div className="test-list-details-performance">
            {testDashboardId !== null && (
              <div>
                How have I been doing?{"  "}
                <span
                  className="test-details-logout"
                  onClick={() => this.openDashboard(testDashboardId)}
                >
                  Click here
                </span>
              </div>
            )}
          </div>
        )}
        {beans.map((d, j) => {
          var button;
          var sedate = "";
          if (d.startDate != "--") {
            sedate = d.startDate + "-" + d.endDate;
          } else {
            sedate = <br />;
          }

          if (d.status == "Launch") {
            /*var oldTests = JSON.parse(localStorage.getItem('tests')) || [];
        if (oldTests.filter(test=> test.id == d.id).length == 0){
          button =  <button onClick={() => this.downloadTest(d.id)} className="download blue-card">Start</button>
        }else{
          button=  <button onClick={() => this.routeChange('/test-instructions/'+this.props.match.params.id+'/'+d.id, d.id)} className="download blue-card">Start</button>
          for(var i=0; i<oldTests.length; i++){
            if(oldTests[i].submit==1 && (oldTests[i].id==d.id)){
              button=  <button onClick={() => this.routeChange2('/test-submit/'+this.props.match.params.id+'/'+d.id)} className="download blue-card">Submit</button>
            }else if(oldTests[i].resume==1 && (oldTests[i].id==d.id)){
              button=  <button onClick={() => this.routeChange('/test-instructions/'+this.props.match.params.id+'/'+d.id, d.id)} className="download blue-card">Resume</button>
            }
          }
        }*/
            var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
            button = (
              <button
                onClick={() =>
                  this.openTest(d.id, d.resultViewer, d.feedbackForm)
                }
                className="download launch-button"
              >
                Start
              </button>
            );
          } else if (d.status == "Time Out") {
            var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
            button = this.showTimoutTest(d.endDate) ? (
              <button
                onClick={
                  () =>
                    this.submitTimeOut(
                      d.id
                    ) /*this.showAlert("The test is closed at  "+d.endDate)*/
                }
                className="download time-out-button"
              >
                {d.status}
              </button>
            ) : null;
            for (var i = 0; i < oldTests.length; i++) {
              if (oldTests[i].resume == 1 && oldTests[i].id == d.id) {
                button = (
                  <button
                    onClick={() =>
                      this.routeChange2(
                        "/test-submit/" +
                          this.props.match.params.id +
                          "/" +
                          d.id
                      )
                    }
                    className="download time-out-button"
                  >
                    {d.status}
                  </button>
                );
              }
            }
          } else if (d.status == "View Result") {
            button = (
              <button
                onClick={() =>
                  this.routeChange2(
                    "/test-result/" + this.props.match.params.id + "/" + d.id,
                    d.endDate
                  )
                }
                className="download result-button"
              >
                Result
              </button>
            );
          } else if (d.status == "Coming Soon") {
            button = (
              <button
                onClick={() =>
                  this.showAlert("The test is available between " + sedate)
                }
                className="download coming-soon-button"
              >
                {d.status}
              </button>
            );
          } else if (d.status === "Admit Card") {
            button = (
              <button
                onClick={() =>
                  this.routeChange4("/admitcard", {
                    testTime: d.startDate,
                    testName: d.name,
                    centreName: d.registeredTestCentreName,
                    centreAddress: d.registeredTestCentreAddress,
                  })
                }
                className="download launch-button"
              >
                {d.status}
              </button>
            );
          } else if (d.status === "Registered") {
            button = (
              <button
                onClick={() =>
                  this.routeChange4("/admitcard", {
                    testTime: d.startDate,
                    testName: d.name,
                    centreName: d.registeredTestCentreName,
                    centreAddress: d.registeredTestCentreAddress,
                  })
                }
                className="download launch-button"
              >
                Admit Card
              </button>
            );
          } else if (d.status === "Open For Registration") {
            button = (
              <button
                onClick={() =>
                  this.routeChange4(`/registercentre/${d.id}`, {
                    testStartDate: d.startDate,
                    testName: d.name,
                  })
                }
                className="download register-button"
              >
                Register
              </button>
            );
          }

          return (
            button && (
              <Card className="background-transparent">
                <Card.Body>
                  <div className="cardbody background-transparent">
                    <FontAwesomeIcon className="Book" icon={faFileAlt} />
                    <p className="option">
                      {d.name}
                      <div className="testdate">{sedate}</div>
                    </p>
                    {button}
                  </div>
                </Card.Body>
              </Card>
            )
          );
        })}
        {footer && (
          <div
            className="test-list-footer"
            dangerouslySetInnerHTML={{ __html: footer }}
          />
        )}
      </div>
    );
  }

  convertRegisterToStart = (testStartTime) => {
    if (!testStartTime || testStartTime === "--") return false;
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    // if (dd < 10) dd = "0" + dd;
    // if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy.toString().substring(2);

    if (testStartTime.includes(formattedToday)) return true;
    else return false;
  };

  renderTestListDesktop(beans) {
    const { getTestDahboardById, getTestFooter } = this.context;
    const { id } = this.props.match.params;
    let testIndex = 0;
    // const { showAdmitcardDownload } = this.state;
    const testDashboardId = getTestDahboardById(Number(id));
    const footer = getTestFooter(Number(id));
    return (
      <div>
        {testDashboardId !== null && (
          <div className="test-list-details-performance">
            {testDashboardId !== null && (
              <div>
                How have I been doing?{"  "}
                <span
                  className="test-details-logout"
                  onClick={() => this.openDashboard(testDashboardId)}
                >
                  Click here
                </span>
              </div>
            )}
          </div>
        )}
        {this.state.loopCount==0&&( 
            <Card className="background-transparent">
              <Card.Body>
                <div className="cardbody head align-center background-transparent">
                  <span className="sno">#</span>
                  <h4 className="head">Name</h4>
                  <span className="date">Start Date</span>
                  <span className="date">End Date</span>
                  <span>Action</span>
                </div>
              </Card.Body>
            </Card>
            )}
      
        { 
        beans.map((d, j) => {
          var button;
          var sedate = "";
          if (d.startDate != "--") {
            sedate = d.startDate + "-" + d.endDate;
          } else {
            sedate = <br />;
          }
          /** for desktop test launch code start */

          if (
            d.status == "Launch" ||
            d.status == "Practice" ||
            d.status == "Quiz"
          ) {
            var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
            button = (
              <button
                onClick={() =>
                  this.openTest(d.id, d.resultViewer, d.feedbackForm)
                }
                className="download launch-button"
              >
                Start
              </button>
            );
          } else if (d.status == "Time Out") {
            var oldTests = JSON.parse(localStorage.getItem("tests")) || [];
            button = this.showTimoutTest(d.endDate) ? (
              <button
                onClick={
                  () =>
                    this.submitTimeOut(
                      d.id
                    ) /*this.showAlert("The test is closed at  "+d.endDate)*/
                }
                className="download time-out-button"
              >
                {d.status}
              </button>
            ) : null;
            for (var i = 0; i < oldTests.length; i++) {
              if (oldTests[i].resume == 1 && oldTests[i].id == d.id) {
                button = (
                  <button
                    onClick={() =>
                      this.routeChange2(
                        "/test-submit/" +
                          this.props.match.params.id +
                          "/" +
                          d.id
                      )
                    }
                    className="download time-out-button"
                  >
                    {d.status}
                  </button>
                );
              }
            }
          } else if (d.status == "View Result") {
            button = (
              <button
                onClick={() =>
                  this.routeChange2(
                    "/test-result/" + this.props.match.params.id + "/" + d.id,
                    d.endDate
                  )
                }
                className="download result-button"
              >
                Result
              </button>
            );
          } else if (d.status == "Coming Soon") {
            button = (
              <button
                onClick={() =>
                  this.showAlert("The test is available between " + sedate)
                }
                className="download coming-soon-button"
              >
                {d.status}
              </button>
            );
          } else if (d.status == "Admit Card") {
            button = (
              <button
                onClick={() =>
                  this.routeChange4("/admitcard", {
                    testTime: d.startDate,
                    testName: d.name,
                    centreName: d.registeredTestCentreName,
                    centreAddress: d.registeredTestCentreAddress,
                  })
                }
                className="download launch-button"
              >
                {d.status}
              </button>
            );
          } else if (d.status === "Registered") {
            button = (
              <button
                onClick={() =>
                  this.routeChange4("/admitcard", {
                    testTime: d.startDate,
                    testName: d.name,
                    centreName: d.registeredTestCentreName,
                    centreAddress: d.registeredTestCentreAddress,
                  })
                }
                className="download launch-button"
              >
                Admit Card
              </button>
            );
          } else if (d.status === "Open For Registration") {
            button = (
              <button
                onClick={() =>
                  this.routeChange4(`/registercentre/${d.id}`, {
                    testStartDate: d.startDate,
                    testName: d.name,
                  })
                }
                className="download register-button"
              >
                Register
              </button>
            );
          }

          if (button) testIndex += 1;
          this.state.loopCount = this.state.loopCount+1;
          /** for desktop test launch code end */

          return (
            button && (
              <Card className="background-transparent">
                <Card.Body>
                  <div className="cardbody align-center background-transparent">
                    <span className="sno">{this.state.loopCount}</span>
                    <h4 className="head">{d.name}</h4>
                    <span className="date">{d.startDate}</span>
                    <span className="date">{d.endDate}</span>
                    {button}
                  </div>
                </Card.Body>
              </Card>
            )
          );
        })}
        {footer && (
          <div
            className="test-list-footer"
            dangerouslySetInnerHTML={{ __html: footer }}
          />
        )}
      </div>
    );
  }
}

export default TestListDetails;
